import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=2cb504fe&scoped=true&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "./Import.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Import.vue?vue&type=style&index=1&id=2cb504fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb504fe",
  null
  
)

component.options.__file = "Import.vue"
export default component.exports